<template>
  <div class="incidents">
    <div v-if="loading" class="loading">
      <div class="spinner"></div>
      <span>Carregando incidentes...</span>
    </div>
    <div v-else-if="activeIncidents.length === 0" class="no-incidents">
      Nenhum incidente ativo no momento.
    </div>
    <div v-else v-for="(incident, index) in activeIncidents" :key="incident.id" class="incident-card">
      <div class="incident-header" @click="toggleActiveTimeline(index)">
        <h3>{{ incident.title }}</h3>
        <div class="badge" :class="getStatusClass(incident.status)">{{ translateStatus(incident.status) }}</div>
      </div>

      <transition name="fade">
        <div v-show="incident.showTimeline" class="incident-timeline">
          <template v-if="incident.messages && incident.messages.length">
            <div v-for="(message, msgIndex) in incident.messages" :key="msgIndex" class="timeline-item">
              <div class="time">{{ formatDate(message.date) }}</div>
              <div class="status-badge" :class="getStatusClass(message.status)">{{ translateStatus(message.status) }}</div>
              <div class="message">{{ message.text }}</div>
            </div>
          </template>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import statusMixin from '../mixins/statusMixin';

export default {
  name: 'ActiveIncidents',
  mixins: [statusMixin],

  computed: {
    ...mapState({
      activeIncidents: (state) => state.status.activeIncidents,
      loading: (state) => state.status.loading,
    }),
  },

  methods: {
    ...mapMutations({
      toggleActiveTimeline: 'status/toggleActiveTimeline',
    }),

    formatDate(date) {
      return new Date(date).toLocaleString('pt-BR');
    },
  },
};
</script>

<style lang="scss" scoped>
.incidents {
  margin-left: -10px;
  margin-right: -10px;
  margin-bottom: 2rem;

  .incident-timeline {
    @apply mt-2;
  }
}

.incident-card {
  @apply bg-white;
  @apply rounded-lg;
  @apply shadow-sm;
  @apply mb-4;
  @apply p-4;
  @apply border;
  @apply border-gray-200;

  .incident-header {
    @apply flex;
    @apply justify-between;
    @apply items-center;
    @apply cursor-pointer;
    @apply p-2;
    @apply -mx-2;
    @apply rounded;
    transition: background-color 0.2s ease;

    &:hover {
      background-color: #f9fafb;
    }

    h3 {
      @apply text-lg;
      @apply font-semibold;
    }
  }
}

.incident-timeline {
  @apply border-t;
  @apply border-gray-100;

  .timeline-item {
    @apply mb-1;
    @apply flex;
    @apply items-start;
    @apply pl-4;
    @apply border-l-2;
    @apply border-gray-200;
    @apply text-sm;

    .time {
      @apply text-gray-500;
      min-width: 150px;
      margin-right: 1rem;
    }

    .status-badge {
      min-width: 120px;
      margin-right: 1rem;
    }

    .message {
      @apply flex-1;
    }

    &:last-child {
      @apply mb-0;
    }
  }
}

.badge {
  @apply px-3;
  @apply py-1;
  @apply rounded-full;
  @apply text-sm;
  @apply font-medium;

  &.-success {
    @apply bg-green-100;
    @apply text-green-800;
  }

  &.-warning {
    @apply bg-yellow-100;
    @apply text-yellow-800;
  }

  &.-info {
    @apply bg-blue-100;
    @apply text-blue-800;
  }

  &.-danger {
    @apply bg-red-100;
    @apply text-red-800;
  }
}

.no-incidents {
  @apply text-center;
  @apply py-8;
  @apply text-gray-500;
}

.fade-enter-active, .fade-leave-active {
  transition: all 0.3s ease;
  max-height: 500px;
  opacity: 1;
}

.fade-enter, .fade-leave-to {
  max-height: 0;
  opacity: 0;
  overflow: hidden;
}
</style>
